import Lottie from "lottie-react";

import animationData from "@app-assets/lotties/error.json";

export default function ErrorAnimation({ size = 100 }: { size?: number }) {
  return (
    <Lottie
      animationData={animationData}
      autoPlay
      loop
      style={{ width: size, height: size }}
    />
  );
}
